import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../context/AuthContext';
import { useArtworksContext } from '../hooks/useArtworksContext';

const ArtworkPriceField = ({ artwork, canEdit }) => {
  const { dispatch } = useArtworksContext();
  const [price, setPrice] = useState(
    artwork.price != null && artwork.price !== '' ? String(artwork.price) : ''
  );
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setPrice(artwork.price != null && artwork.price !== '' ? String(artwork.price) : '');
  }, [artwork._id, artwork.price]);

  const handleSave = async () => {
    const numericPrice = Number(price);
    if (!Number.isFinite(numericPrice) || numericPrice < 0.5) {
      setError('Price must be at least $0.50');
      return;
    }

    setIsSaving(true);
    setError('');
    try {
      const response = await axiosInstance.patch(`/artworks/${artwork._id}`, {
        price: numericPrice,
      });
      dispatch({ type: 'UPDATE_ARTWORK', payload: response.data });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update price');
    } finally {
      setIsSaving(false);
    }
  };

  if (!canEdit) {
    return (
      <div className="flex flex-col items-center text-white">
        <span className="font-bold text-base">
          {artwork.price != null ? `$${Number(artwork.price).toFixed(2)}` : '—'}
        </span>
        <span className="text-amber-300 text-xs">Price</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center text-white min-w-[5.5rem]">
      <div className="flex items-center gap-1">
        <span className="text-sm">$</span>
        <input
          type="number"
          min="0.50"
          step="0.01"
          value={price}
          onChange={(e) => {
            setPrice(e.target.value);
            setError('');
          }}
          className="w-20 rounded bg-slate-700 px-1.5 py-0.5 text-sm text-white border border-slate-500 focus:border-emerald-400 focus:outline-none"
          aria-label="Artwork price"
        />
      </div>
      <button
        type="button"
        onClick={handleSave}
        disabled={isSaving}
        className="mt-1 text-[10px] uppercase tracking-wide text-emerald-300 hover:text-emerald-200 disabled:opacity-50"
      >
        {isSaving ? 'Saving…' : saved ? 'Saved' : 'Update'}
      </button>
      {error && <p className="mt-1 text-[10px] text-red-300 text-center">{error}</p>}
    </div>
  );
};

export default ArtworkPriceField;
